import React, { useState, useRef } from "react";

// item: product object (must have productImage, optionally productColors)
// alt: alt text for image
function ProductImageSlideshow({ item, alt }) {
  const [slideshowIndex, setSlideshowIndex] = useState(0);
  const slideshowInterval = useRef(null);

  // Get all images for the slideshow: main image + productColors images
  const getSlideshowImages = (item) => {
    let images = [item.productImage];
    if (
      item.productColors &&
      Array.isArray(item.productColors) &&
      item.productColors.length > 0
    ) {
      images = [item.productImage, ...item.productColors.map((c) => c.image)];
    }
    // Remove duplicates and falsy values
    return images.filter((img, idx, arr) => img && arr.indexOf(img) === idx);
  };

  const images = getSlideshowImages(item);

  // Handle hover logic for slideshow
  const handleMouseEnter = () => {
    if (images.length > 1) {
      setSlideshowIndex(0);
      slideshowInterval.current = setInterval(() => {
        setSlideshowIndex((prev) => (prev + 1) % images.length);
      }, 1000);
    }
  };

  const handleMouseLeave = () => {
    clearInterval(slideshowInterval.current);
    setSlideshowIndex(0);
  };

  return (
    <div
      className="premium-img-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        position: "relative",
        borderRadius: "14px",
        overflow: "hidden",
        paddingBottom: "125%",
      }}
    >
      {images.map((img, idx) => (
        <img
          key={idx}
          src={img}
          className={`card-img-top card-img-custom premium-img ${
            slideshowIndex === idx
              ? "premium-img-visible"
              : "premium-img-hidden"
          }`}
          alt={alt}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "14px",
            background:
              "linear-gradient(135deg, rgba(40,40,40,0.12) 0%, rgba(80,80,80,0.08) 100%)",
          }}
        />
      ))}
    </div>
  );
}

export default ProductImageSlideshow; 